import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=07fcaa42&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=ts"
export * from "./Buttons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fcaa42",
  null
  
)

export default component.exports